// Assignment Document Fields JavaScript
export function initializeAssignmentDocuments() {
  // ファイル選択時のプレビュー機能
  document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.nested-fields');
    
    containers.forEach(container => {
      const fileInput = container.querySelector('input[type="file"]');
      const previewArea = container.querySelector('.file-preview-area');
      const fileName = container.querySelector('.file-name');
      const fileSize = container.querySelector('.file-size');
      const clearBtn = container.querySelector('.clear-file');
      
      if (fileInput) {
        fileInput.addEventListener('change', function() {
          if (this.files.length > 0) {
            const file = this.files[0];
            if (fileName) fileName.textContent = file.name;
            if (fileSize) fileSize.textContent = formatFileSize(file.size);
            if (previewArea) previewArea.style.display = 'block';
          } else {
            if (previewArea) previewArea.style.display = 'none';
          }
        });
      }
      
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          if (fileInput) fileInput.value = '';
          if (previewArea) previewArea.style.display = 'none';
        });
      }
    });
  });
  
  // Cocoonで動的に追加された要素にもイベントを適用
  document.addEventListener('cocoon:after-insert', function(e) {
    const newContainer = e.detail.insertedItem;
    if (newContainer.querySelector('.nested-fields')) {
      initializeFilePreview(newContainer);
    }
  });
}

function initializeFilePreview(container) {
  const fileInput = container.querySelector('input[type="file"]');
  const previewArea = container.querySelector('.file-preview-area');
  const fileName = container.querySelector('.file-name');
  const fileSize = container.querySelector('.file-size');
  const clearBtn = container.querySelector('.clear-file');
  
  if (fileInput) {
    fileInput.addEventListener('change', function() {
      if (this.files.length > 0) {
        const file = this.files[0];
        if (fileName) fileName.textContent = file.name;
        if (fileSize) fileSize.textContent = formatFileSize(file.size);
        if (previewArea) previewArea.style.display = 'block';
      } else {
        if (previewArea) previewArea.style.display = 'none';
      }
    });
  }
  
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      if (fileInput) fileInput.value = '';
      if (previewArea) previewArea.style.display = 'none';
    });
  }
}

function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// 自動初期化
initializeAssignmentDocuments();
